import React, { useMemo } from 'react';
import { Layout } from 'antd';
import { ContainerPanel, CompsTable, ContainerModal, CompsForm, GenericCardsStatistic } from '@ms/shared-components';
import ConfigTree from './components/ConfigTree';
import { useComponent } from './hooks/useComponent';
import {
  getFormItems,
  getColumns,
  getTreePanelButtons,
  getTablePanelButtons,
  tableConfig,
  modalConfig,
  getModalFooterButtons,
  getModalTitle,
  formConfig,
  getStatisticCards,
} from './config';
import { getFormInitialValues } from './utils';
import '../shared/ai-config.css';

const { Sider, Content } = Layout;

const ComponentPage: React.FC = () => {
  const {
    components,
    treeData,
    loading,
    modalVisible,
    editingRecord,
    setFormRef,
    statistics,
    loadComponents,
    loadTreeData,
    handleSelect,
    handleOpenModal,
    handleCloseModal,
    handleSave,
    handleDelete,
    handleToggleActive,
    expandedKeys,
    selectedKeys,
    setExpandedKeys,
  } = useComponent();

  const formItems = useMemo(
    () => getFormItems(editingRecord),
    [editingRecord]
  );
  const columns = useMemo(
    () => getColumns(handleOpenModal, handleDelete, handleToggleActive),
    [handleOpenModal, handleDelete, handleToggleActive]
  );
  const initialValues = useMemo(
    () => getFormInitialValues(editingRecord),
    [editingRecord]
  );
  const treeButtons = useMemo(
    () =>
      getTreePanelButtons({
        onRefresh: loadTreeData,
        onCreate: () => handleOpenModal(),
      }),
    [loadTreeData, handleOpenModal]
  );
  const tableButtons = useMemo(
    () => getTablePanelButtons({ onRefresh: loadComponents }),
    [loadComponents]
  );
  const footerButtons = useMemo(
    () => getModalFooterButtons(handleCloseModal, handleSave),
    [handleCloseModal, handleSave]
  );
  const modalTitle = useMemo(
    () => getModalTitle(!!editingRecord),
    [editingRecord]
  );

  const statisticCards = useMemo(
    () => getStatisticCards(statistics),
    [statistics]
  );

  return (
    <div style={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      {/* 统计卡片 */}
      <div style={{ padding: '16px', background: '#fff', borderBottom: '1px solid #f0f0f0' }}>
        <GenericCardsStatistic data={statisticCards} columns={7} />
      </div>

      <Layout style={{ flex: 1, display: 'flex', gap: 16, backgroundColor: '#fff', overflow: 'hidden' }}>
        <Sider
          width={400}
          style={{
            background: '#fff',
            borderRight: '1px solid #f0f0f0',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 0,
          }}
        >
              <ContainerPanel 
                title="关系树" 
                buttons={treeButtons}
                height={'100%'}
              >
              <ConfigTree
                treeData={treeData}
                selectedKeys={selectedKeys}
                expandedKeys={expandedKeys}
                onSelect={handleSelect}
                onExpand={setExpandedKeys}
                onAddNode={() => {}}
              />
              </ContainerPanel>
        </Sider>
        <Content
          style={{
            overflow: 'auto',
            backgroundColor: '#fff',
            height: '100%',
          }}
        >
            <ContainerPanel title="组件列表" buttons={tableButtons} height={'100%'}>
              <CompsTable
                resizableColumns
                storageKey="msai-component"
                tableProps={{
                  columns: columns as any,
                  dataSource: components,
                  rowKey: tableConfig.rowKey as any,
                  loading,
                  scroll: { x: 1200 },
                  pagination: tableConfig.pagination,
                  // 禁用树形结构，移除展开/折叠图标
                  childrenColumnName: 'noChildren',  // 设置为不存在的字段名
                  indentSize: 0,  // 设置缩进为0
                } as any}
              />
            </ContainerPanel>
        </Content>
      </Layout>

      <ContainerModal
        title={modalTitle}
        visible={modalVisible}
        onCancel={handleCloseModal}
        width={modalConfig.width}
        height={modalConfig.height}
        contentPadding={modalConfig.contentPadding}
        footerRightButtons={footerButtons}
        modalProps={modalConfig.modalProps}
      >
        <CompsForm
          formItems={formItems}
          formRef={setFormRef}
          initialValues={initialValues}
          layout={formConfig.layout}
          contentPadding={formConfig.contentPadding}
        />
      </ContainerModal>
    </div>
  );
};

export default ComponentPage;
